import type { IconData } from '@stacksjs/iconify-core'

export const phoneIncomingCall: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 18.29h-9.15v3.04h1.53v1.53h7.62v3.04H32V15.24h-1.52zm-1.53 7.61h1.53v1.53h-1.53Zm0-12.19h1.53v1.53h-1.53Zm-1.52-1.52h1.52v1.52h-1.52Zm0 13.71H25.9v1.53h-1.52v1.52h4.57v-1.52h-1.52zm-3.05-1.52h1.52v1.52h-1.52Zm0-22.86h1.52v1.53h-1.52ZM22.86 25.9h1.52v1.53h-1.52Zm0-22.85h1.52v1.52h-1.52Zm-3.05 25.9h4.57v1.53h-4.57Zm1.52-24.38h1.53V6.1h-1.53ZM10.67 16.76h10.66v1.53H10.67Zm4.57-15.24h1.52V6.1h-1.52Zm-6.1 3.05h1.53V6.1H9.14ZM1.52 18.29v-3.05H0v6.09h1.52v1.53h7.62v-1.53h1.53v-3.04zm6.1-15.24h1.52v1.52H7.62Zm-3.05 7.62h22.86v1.52H4.57Zm1.52-9.15h1.53v1.53H6.09ZM3.05 12.19h1.52v1.52H3.05Z\"/><path fill=\"currentColor\" d=\"M1.52 13.71h1.53v1.53H1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default phoneIncomingCall
